<template>
    <div class="d-flex wrap-app-shortcuts" :class="{ 'full-width': userCustomShortcuts.length > 0 }">
        <div v-if="selected_layout == 1" class="d-flex full-width" data-cy="dashboard-shortcut-cards">
            <v-row class="fill-height">
                <v-col cols="12" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[0]"> </shortcut-card>
                </v-col>

                <v-col cols="12" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[1]"> </shortcut-card>
                </v-col>

                <v-col cols="12" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[2]"> </shortcut-card>
                </v-col>
            </v-row>
        </div>

        <div v-if="selected_layout == 2" class="full-width d-flex" data-cy="dashboard-shortcut-cards">
            <v-row class="fill-height">
                <v-col cols="12" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[0]"> </shortcut-card>
                </v-col>

                <v-col cols="12" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[1]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[2]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[3]"> </shortcut-card>
                </v-col>
            </v-row>
        </div>

        <div v-if="selected_layout == 3" class="full-width d-flex" data-cy="dashboard-shortcut-cards">
            <v-row class="fill-height">
                <v-col cols="12" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[0]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[1]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[2]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[3]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[4]"> </shortcut-card>
                </v-col>
            </v-row>
        </div>

        <div v-if="selected_layout == 4" class="full-width d-flex" data-cy="dashboard-shortcut-cards">
            <v-row class="fill-height">
                <v-col cols="6" class="d-flex shortcut shortcut-1">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[0]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex shortcut shortcut-2">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[1]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex shortcut shortcut-3">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[2]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex shortcut shortcut-4">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[3]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex shortcut shortcut-5">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[4]"> </shortcut-card>
                </v-col>

                <v-col cols="6" class="d-flex shortcut shortcut-6">
                    <shortcut-card :userCustomShortcuts="userCustomShortcuts[5]"> </shortcut-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        selected_layout: Number,
        number_of_cards: Number,
        userCustomShortcuts: Array,
    },
};
</script>

<style></style>
